import Crud from '../components/Role/Crud'

let routes = {
    path: '/roles',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/roles/:operation?/:id?',
            name: 'Cargos',
            component: Crud
        }
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/role.js